module.exports = __webpack_public_path__ + "img/selected2-min.ac1fc7b9.png";